import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import store from '@/store';
import router from '@/router';
import initAuthService from '@/services/authService';
import App from './App.vue';
import 'whatwg-fetch';
library.add(fas);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(VueCompositionAPI);
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');
initAuthService(store, router);
